// AUTO-GENERATED — do not edit.
// Source: business/ishvaram/data/contracts/value_surface_placements.yaml
// Regenerate: uv run python execution/generate_offer_placement_ts.py

// Individually tree-shakable browser keys; contains no policy catalog.

export const RUNTIME_OFFER_PLACEMENT_DASAMSA_REPORT_BRIDGE = "/dasamsa_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_DASHA_CALCULATOR_REPORT_BRIDGE =
  "/dasha-calculator_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_DASAMSA_REPORT_BRIDGE =
  "/hi/dasamsa_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_DASHA_CALCULATOR_REPORT_BRIDGE =
  "/hi/dasha-calculator_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_KAAL_SARP_DOSHA_REPORT_BRIDGE =
  "/hi/kaal-sarp-dosha_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_LAL_KITAB_REPORT_BRIDGE =
  "/hi/lal_kitab_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_MUHURAT_REPORT_BRIDGE =
  "/hi/muhurat_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_NAVAMSA_CHART_REPORT_BRIDGE =
  "/hi/navamsa_chart_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_PITRA_DOSHA_REPORT_BRIDGE =
  "/hi/pitra-dosha_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_RASHI_CALCULATOR_REPORT_BRIDGE =
  "/hi/rashi_calculator_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_SADE_SATI_REPORT_BRIDGE =
  "/hi/sade-sati_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_SHADBALA_REPORT_BRIDGE =
  "/hi/shadbala_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_KAAL_SARP_DOSHA_REPORT_BRIDGE =
  "/kaal-sarp-dosha_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_LAL_KITAB_REPORT_BRIDGE = "/lal_kitab_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_MUHURAT_REPORT_BRIDGE = "/muhurat_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_NAVAMSA_CHART_REPORT_BRIDGE =
  "/navamsa_chart_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_PITRA_DOSHA_REPORT_BRIDGE =
  "/pitra-dosha_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_RASHI_CALCULATOR_REPORT_BRIDGE =
  "/rashi_calculator_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_SADE_SATI_REPORT_BRIDGE = "/sade-sati_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_SHADBALA_REPORT_BRIDGE = "/shadbala_report_bridge" as const;
export const RUNTIME_OFFER_PLACEMENT_BABY_NAME_LOOKUP_BELOW_RESULT =
  "baby_name_lookup_below_result" as const;
export const RUNTIME_OFFER_PLACEMENT_BIRTH_IDENTITY_LOOKUP_BELOW_RESULT =
  "birth_identity_lookup_below_result" as const;
export const RUNTIME_OFFER_PLACEMENT_CHAT_READING_PRIMARY = "chat-reading-primary" as const;
export const RUNTIME_OFFER_PLACEMENT_CHAT_EARLY_QUICK_OFFER = "chat_early_quick_offer" as const;
export const RUNTIME_OFFER_PLACEMENT_CHAT_PAYWALL = "chat_paywall" as const;
export const RUNTIME_OFFER_PLACEMENT_GUN_MILAN_RESULTS_PRIMARY =
  "gun_milan_results_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_HI_GUN_MILAN_RESULTS_PRIMARY =
  "hi_gun_milan_results_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_KAAL_SARP_RESULT_PRIMARY = "kaal_sarp_result_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_KUNDALI_RESULT_PRIMARY = "kundali-result-primary" as const;
export const RUNTIME_OFFER_PLACEMENT_KUNDLI_MATCHING_RESULTS_PRIMARY =
  "kundli_matching_results_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_MANGAL_DOSHA_RESULT_PRIMARY =
  "mangal_dosha_result_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_MATCH_SHARE_RESULTS_PRIMARY =
  "match_share_results_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_MUHURAT_EVENT_VALUE_MOMENT =
  "muhurat_event_value_moment" as const;
export const RUNTIME_OFFER_PLACEMENT_NUMEROLOGY_LOOKUP_BELOW_RESULT =
  "numerology_lookup_below_result" as const;
export const RUNTIME_OFFER_PLACEMENT_PITRA_DOSH_RESULT_PRIMARY =
  "pitra_dosh_result_primary" as const;
export const RUNTIME_OFFER_PLACEMENT_REPORT_READING_UPSELL = "report_reading_upsell" as const;
export const RUNTIME_OFFER_PLACEMENT_SHANI_TRANSIT_BELOW_RESULT =
  "shani_transit_below_result" as const;

export type RuntimeOfferPlacementKey =
  | typeof RUNTIME_OFFER_PLACEMENT_DASAMSA_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_DASHA_CALCULATOR_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_DASAMSA_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_DASHA_CALCULATOR_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_KAAL_SARP_DOSHA_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_LAL_KITAB_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_MUHURAT_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_NAVAMSA_CHART_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_PITRA_DOSHA_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_RASHI_CALCULATOR_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_SADE_SATI_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_HI_SHADBALA_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_KAAL_SARP_DOSHA_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_LAL_KITAB_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_MUHURAT_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_NAVAMSA_CHART_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_PITRA_DOSHA_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_RASHI_CALCULATOR_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_SADE_SATI_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_SHADBALA_REPORT_BRIDGE
  | typeof RUNTIME_OFFER_PLACEMENT_BABY_NAME_LOOKUP_BELOW_RESULT
  | typeof RUNTIME_OFFER_PLACEMENT_BIRTH_IDENTITY_LOOKUP_BELOW_RESULT
  | typeof RUNTIME_OFFER_PLACEMENT_CHAT_READING_PRIMARY
  | typeof RUNTIME_OFFER_PLACEMENT_CHAT_EARLY_QUICK_OFFER
  | typeof RUNTIME_OFFER_PLACEMENT_CHAT_PAYWALL
  | typeof RUNTIME_OFFER_PLACEMENT_GUN_MILAN_RESULTS_PRIMARY
  | typeof RUNTIME_OFFER_PLACEMENT_HI_GUN_MILAN_RESULTS_PRIMARY
  | typeof RUNTIME_OFFER_PLACEMENT_KAAL_SARP_RESULT_PRIMARY
  | typeof RUNTIME_OFFER_PLACEMENT_KUNDALI_RESULT_PRIMARY
  | typeof RUNTIME_OFFER_PLACEMENT_KUNDLI_MATCHING_RESULTS_PRIMARY
  | typeof RUNTIME_OFFER_PLACEMENT_MANGAL_DOSHA_RESULT_PRIMARY
  | typeof RUNTIME_OFFER_PLACEMENT_MATCH_SHARE_RESULTS_PRIMARY
  | typeof RUNTIME_OFFER_PLACEMENT_MUHURAT_EVENT_VALUE_MOMENT
  | typeof RUNTIME_OFFER_PLACEMENT_NUMEROLOGY_LOOKUP_BELOW_RESULT
  | typeof RUNTIME_OFFER_PLACEMENT_PITRA_DOSH_RESULT_PRIMARY
  | typeof RUNTIME_OFFER_PLACEMENT_REPORT_READING_UPSELL
  | typeof RUNTIME_OFFER_PLACEMENT_SHANI_TRANSIT_BELOW_RESULT;
